export const encodeData = (obj: Record<string, any>) => {
  // Check if obj is an object
  if (typeof obj !== 'object' || obj === null || obj instanceof Date) {
    return obj;
  }

  // If obj is an array, recursively encode each element
  if (Array.isArray(obj)) {
    return obj.map(encodeData);
  }

  // Recursively encode each property
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === 'object' && value !== null
        ? encodeData(value)
        : typeof value === 'string'
        ? btoa(value as any) // ? encodeURIComponent(value as any)
        : value,
    ])
  );
};
